<template>
  <div class="new-login-page">
    <div class="login-banner">
      <div class="login-pic">
        <img src="../assets/login_temp/login_house.png" class="house-image">
      </div>
      <div class="login-info">
        <img src="../assets/login/login_scan.png" v-if="!loginByWx" class="scan-image" @click="loginByWx = true">
        <img src="../assets/login/login_computer.png" v-if="loginByWx" class="scan-image" @click="loginByWx = false">
        <img src="../assets/login_temp/login_by_scan.png" v-if="!loginByWx" class="tip-image" @click="loginByWx = true">
        <img src="../assets/login_temp/login_by_password.png" v-if="loginByWx" class="tip-image" @click="loginByWx = false">

          <div class="login-details">
            <img src="../assets/login/login_logo.png">
            <div class="login-divide"></div>
            <div class="login-name">数智公寓</div>

                  <div class="wx-login-box-out" v-if="loginByWx">
                    <wx-login v-if="loginByWx" :appid="wxConfig.appid" :scope="wxConfig.scope" :redirect_uri="wxConfig.redirect_uri" :theme="wxConfig.theme" class="wx-login-box" :href="wxConfig.href" />
                  </div>
                  <div v-if="loginByWx" class="login-scan-desc">
                    <div>使用微信扫描二维码登录</div>
                    <div>“数智公寓平台”</div>
                  </div>

                  <div class="login-pass" v-if="!loginByWx">
                    <div class="login-enter">
                      <div class="login-desc">公寓名称</div>
                      <el-input placeholder="请输入公寓名称" v-model="yqCode" size="small" class="login-input"/>
                    </div>
                    <div class="login-enter">
                      <div class="login-desc">账号</div>
                      <el-input placeholder="请输入账号" v-model="name" size="small" class="login-input"/>
                    </div>
                    <div class="login-enter">
                      <div class="login-desc">密码</div>
                      <el-input placeholder="请输入密码" v-model="password" type="password" size="small" class="login-input"/>
                    </div>
                    <div class="login-enter">
                      <div class="login-desc">验证码</div>
                      <div style="display: flex;align-items: flex-end;">
                      <el-input placeholder="请输入验证码" v-model="identityCode" size="small" class="login-input2" @keyup.13.native="login"/>
                      <img :src="codeImg" alt="验证码" class="codeImg" @click="getIdentityCode">
                      </div>
                    </div>
                  </div>

                  <div class="loginBtn" @click="login" v-if="!loginByWx">登录</div>
                  <div style="margin-top: 10px;cursor: pointer;" v-if="!loginByWx"><span @click="TopswForget">忘记密码？</span></div>

          </div>
      </div>
    </div>
<!--      <div class="login_info"></div>-->

    <!--    <div class="login-banner">-->

    <!--        <div class="login-message">-->
    <!--          <img src="../assets/login/login_logo.png"></img>-->
    <!--&lt;!&ndash;          <div class="login-wel">欢迎登录</div>&ndash;&gt;-->
    <!--          <div class="login-divide"></div>-->
    <!--          <div class="login-name">数智公寓</div>-->
    <!--        </div>-->

    <!--      <div class="wx-login-box-out" v-if="loginByWx">-->
    <!--        <wx-login v-if="loginByWx" :appid="wxConfig.appid" :scope="wxConfig.scope" :redirect_uri="wxConfig.redirect_uri" :theme="wxConfig.theme" class="wx-login-box" :href="wxConfig.href" />-->
    <!--      </div>-->
    <!--      <div v-if="loginByWx" class="login-scan-desc">-->
    <!--        <div>使用微信扫描二维码登录</div>-->
    <!--        <div>“数智公寓平台”</div>-->
    <!--      </div>-->

    <!--      <div class="login-pass" v-if="!loginByWx">-->
    <!--        <div class="login-enter">-->
    <!--          <div class="login-desc">公寓名称</div>-->
    <!--          <el-input placeholder="请输入公寓名称" v-model="yqCode" size="small" class="login-input"/>-->
    <!--        </div>-->
    <!--        <div class="login-enter">-->
    <!--          <div class="login-desc">账号</div>-->
    <!--          <el-input placeholder="请输入账号" v-model="name" size="small" class="login-input"/>-->
    <!--        </div>-->
    <!--        <div class="login-enter">-->
    <!--          <div class="login-desc">密码</div>-->
    <!--          <el-input placeholder="请输入密码" v-model="password" type="password" size="small" class="login-input"/>-->
    <!--        </div>-->
    <!--        <div class="login-enter">-->
    <!--          <div class="login-desc">验证码</div>-->
    <!--          <div style="display: flex;align-items: flex-end;">-->
    <!--          <el-input placeholder="请输入验证码" v-model="identityCode" size="small" class="login-input2" @keyup.13.native="login"/>-->
    <!--          <img :src="codeImg" alt="验证码" class="codeImg" @click="getIdentityCode">-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="loginBtn" @click="login" v-if="!loginByWx">登录</div>-->

    <!--    </div>-->
  </div>

</template>

<script>
/* eslint-disable */
import md5 from 'js-md5'
import bus from '../utils/bus'
import {pattern} from '../utils/regular'
import {errorHandler} from '../utils/errorHandler'
import {errorMessage} from '../utils/errorCode'
import {api} from './api/Login'
import wxLogin from 'vue-wxlogin'
import {jurisdiction} from '../utils/jurisdiction'
import { nError, nSuccess } from "../utils/notice";

export default {
  name: 'login',
  components: {
    wxLogin,
    nError
  },
  data () {
    return {
      loginByWx: false,
      wxConfig: {
        appid: 'wx8910f30473aa9e86',
        scope: 'snsapi_login',
        redirect_uri: 'https://yq.damaiiot.com/yq-auth/wx/wxQrcodeLogin/getKjUrl/gy?host='+window.location.host,
        state: '',
        theme: 'black',
        href: 'https://yq.damaiiot.com/yq/css/wxLoginGY.css',
      },
      yqCode: '',
      name: '',
      password: '',
      identityCode : '',
      promotPro: '',
      codeImg: '',
      randomStr: ''
    }
  },
  created: function () {
    console.log(window.location.host);
    let params = this.getParams();
    if (params.token) {
      params.yqAppCode = params.yqAppCode ? params.yqAppCode.replace('#/login', '') : '';
      this.toHousingPlatform(params);
    } else {
      let hostName = window.location.host;
      if (hostName === 'unicom.damaiiot.com') {
        this.$router.push({
          name: 'login-liantong'
        })
      }
      if (hostName === 'yq.3i-space.com') {
        this.$router.push({
          name: 'login-3i'
        })
      }
      if (hostName === 'yq.hzjkdz.com') {
        this.$router.push({
          name: 'login-3i'
        })
      }
      if (hostName === 'yq.zjrob.com') {
        this.$router.push({
          name: 'login-zjrob'
        })
      }
      this.getIdentityCode()
    }
  },
  methods: {
    TopswForget: function () {
      this.$router.push({
        name: 'resetPassword'
      })
    },
    toHomepage () {
      window.sessionStorage.setItem('navTop', 'workbench')
      this.$router.push({
        name: 'workbench'
      })
    },
    toyqInfoPage () {
      window.sessionStorage.setItem('navTop', 'resource')
      let routerName = ''
      for (let i = 0; i < jurisdiction.length; i++) {
        for (let j = 0; j < jurisdiction[i].children.length; j++) {
          if (bus.global.permissionCodes.indexOf(jurisdiction[i].children[j].id) !== -1 && !routerName) {
            routerName = jurisdiction[i].children[j].routerName
          }
        }
      }
      this.$router.push({
        name: routerName
      })
    },
    getIdentityCode () {
      let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
      let pwd = ''
      for (let i = 0; i < 4; i++) {
        let id = Math.ceil(Math.random()*35)
        pwd += chars[id]
      }
      this.randomStr = pwd
      this.$axios.get(`${api.getIdentityCode}/${this.randomStr}`, {})
        .then(res => {
          this.codeImg = res.data.data
        })
        .catch(errorHandler('获取验证码失败'))
    },
    login () {
      const atn = pattern.accountName
      const psd = pattern.password
      if (!this.yqCode) {
        this.promotPro = '<b>请输入公寓名称</b>'
        return false
      }
      if (!this.name) {
        nError("请输入账号")
        // this.promotPro = '<b>请输入账号</b>'
        return false
      }else if (!atn.test(this.name)) {
        nError("请输入正确的账号格式")
        // this.promotPro = '<b>请输入正确的账号格式</b>'
        return false
      }else {
        this.promotPro = ''
      }
      if (!this.password) {
        nError("请输入密码")
        // this.promotPro = '<b>请输入密码</b>'
        return false
      }else if (!psd.test(this.password)) {
        nError("请输入正确的密码格式")
        // this.promotPro = '<b>请输入正确的密码格式</b>'
        return false
      } else {
        this.promotPro = ''
      }
      if (!this.identityCode) {
        nError("请输入验证码")
        // this.promotPro = '<b>请输入验证码</b>'
        return false
      } else {
        this.promotPro = ''
      }
      let yqCode = this.yqCode.toLowerCase()
      this.promotPro = ''
      let name = this.name.toLowerCase()
      let pw = this.password + name
      let once = md5(pw) + name
      let pwd
      for (let i = 0; i < 9; i++) {
        pwd = md5(once)
        once = pwd + name
      }

      this.$axios.post(api.login, {
        name: name,
        password: pwd,
        identityCode: this.identityCode,
        yqAppCode: this.yqCode,
        randomStr: this.randomStr
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            // if (res.data.data.buildingCode) {
            //   let buildingCode = res.data.data.buildingCode.join(',')
            //   window.sessionStorage.setItem('accountHasBuildingCode', buildingCode)
            //   bus.global.accountHasBuildingCode = buildingCode
            // }
            window.sessionStorage.setItem('accountCode', res.data.data.code)
            window.sessionStorage.setItem('accountName', res.data.data.name)
            window.sessionStorage.setItem('accountPersonCode', data.personCode)
            window.sessionStorage.setItem('accountPersonName', data.personName)
            window.sessionStorage.setItem('token', res.data.data.token)
            window.sessionStorage.setItem('permissionCodes', res.data.data.permissionCodes)
            window.sessionStorage.setItem('yqCode', yqCode)
            bus.global.accountCode = res.data.data.code
            bus.global.accountName = res.data.data.name
            bus.global.personCode = data.personCode
            bus.global.personName = data.personName
            bus.global.token = res.data.data.token
            bus.global.yqCode = yqCode
            bus.global.permissionCodes = res.data.data.permissionCodes
            // if (this.yqCode === 'ahdl') {
            //   bus.global.yqOrEngineer = '工程'
            // } else {
            //   bus.global.yqOrEngineer = '园区'
            // }
            if (data.isFirstTime === '1') {
              if (res.data.data.permissionCodes.indexOf('000000000') === -1) {
                this.toyqInfoPage()
              } else {
                this.toHomepage()
              }
            } else {
              window.sessionStorage.setItem('firstChangeOldPassword', pwd)
              this.$router.push({
                name: 'first-change-password'
              })
            }
          }
        })
        .catch(e => {
          this.$layer.toast({
            icon: 'icon-check',
            content: errorMessage(+e.response.data.data),
            time: 1000
          })
          let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
          let pwd = ''
          for (let i = 0; i < 4; i++) {
            let id = Math.ceil(Math.random()*35)
            pwd += chars[id]
          }
          this.randomStr = pwd
          this.$axios.get(`${api.getIdentityCode}/${this.randomStr}`, {})
            .then(res => {
              this.codeImg = res.data.data
            })
            .catch(errorHandler('获取验证码失败'))
        })
    },

    // 获取当前页面参数
    getParams() {
      let url = window.location.href;
      let urlStr = url.split('?')[1]
      // 创建空对象存储参数
      let obj = {};
      if (url.indexOf('?') > -1) {
        // 再通过 & 将每一个参数单独分割出来
        let paramsArr = urlStr.split('&')
        for(let i = 0,len = paramsArr.length;i < len;i++){
          // 再通过 = 将每一个参数分割为 key:value 的形式
          let arr = paramsArr[i].split('=')
          obj[arr[0]] = arr[1];
        }
      }
      return obj;
    },

    // 单点登录接口
    toHousingPlatform(params) {
      this.$axios.post(api.getApartmentMeg, {}, {headers:{'Content-Type': 'application/x-www-form-urlencoded', token: params.token, 'yq-app-code': params.yqAppCode}})
        .then(res =>{
          if (res.data.retCode === 1) {
            let data = res.data.data
            // if (res.data.data.buildingCode) {
            //   let buildingCode = res.data.data.buildingCode.join(',')
            //   window.sessionStorage.setItem('accountHasBuildingCode', buildingCode)
            //   bus.global.accountHasBuildingCode = buildingCode
            // }
            window.sessionStorage.setItem('accountCode', data.code);
            window.sessionStorage.setItem('accountName', data.name);
            window.sessionStorage.setItem('accountPersonCode', data.personCode);
            window.sessionStorage.setItem('accountPersonName', data.personName);
            window.sessionStorage.setItem('token', data.token);
            window.sessionStorage.setItem('permissionCodes', data.permissionCodes);
            window.sessionStorage.setItem('yqCode', data.parkCode);
            // console.log(data.parkCode, 'parkCode')
            bus.global.accountCode = data.code;
            bus.global.accountName = data.name;
            bus.global.personCode = data.personCode;
            bus.global.personName = data.personName;
            bus.global.token = data.token;
            this.yqCode = bus.global.yqCode = data.parkCode;
            bus.global.permissionCodes = data.permissionCodes;
            let pwd = data.password;
            // 清除url携带的参数
            let url = window.location.href;                    //获取当前页面的url
            if(url.indexOf("?")!=-1){                        //判断是否存在参数
              url = url.replace(/(\?|#)[^'"]*/, '');           //去除参数
              window.history.pushState({},0,url);
            }
            // if (this.yqCode === 'ahdl') {
            //   bus.global.yqOrEngineer = '工程'
            // } else {
            //   bus.global.yqOrEngineer = '园区'
            // }
            if (data.isFirstTime === '1') {
              if (data.permissionCodes.indexOf('000000000') === -1) {
                this.toyqInfoPage()
              } else {
                this.toHomepage()
              }
            } else {
              window.sessionStorage.setItem('firstChangeOldPassword', pwd)
              this.$router.push({
                name: 'first-change-password'
              })
            }
          } else {
            nError(res.data.msg || '获取登录人员信息失败')
          }
        })
        .catch(res =>{
          nError('单点登录失败')
        })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head img {
  width: 250px;
  height: 44px;
  margin: 15px 10px 15px 30px;
}

.head b {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #000000;
}
.head span {
  font-size: 24px;
  font-family: STHeiti;
  font-weight: 600;
  color: #000000;
  line-height: 30px;
  vertical-align: middle;
  display: inline-block;
  padding: 0 10px;
}
.centen {
  width: 100%;
  height: 90%;
  background-color: #EFF1F5;
  position: relative;
}


footer {
  width: 100%;
  font-size: 13px;
  text-align: center;
  color: #999999;
  background-color: #F0F3F7;
  height: 50px;
  line-height: 35px;
}

a:hover {
  cursor: pointer;
}

.codeImg {
  display: inline-block;
  width: 100px;
  height: 28px;
  margin-left: 10px;
  vertical-align: bottom;
}

.codeImg:hover {
  cursor: pointer;
}

#prompt {
  line-height: 16px;
  padding: 0;
  margin: 0;
}

#prompt b {
  display: block;
  width: 100%;
  text-align: center;
  color: red;
  margin-top: 8px;
  margin-bottom: -5px;
}

#pswforget {
  margin: 0;
  padding: 0 33px;
  display: flex;
  justify-content: flex-end;
}

#pswforget span {
  margin: -5px;
  display: inline-block;
  color: #a6a6a6;
}

#pswforget span:hover {
  color: #00A0E6;
  cursor: pointer;
}

#youcode {
  margin: 0;
  display: flex;
  justify-content: space-between;
}

</style>

<style lang="less" scoped>
.new-login-page {
  height: 100%;
  min-height: 685px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: linear-gradient(134deg, #4D96FF 0%, #0051B1 100%);
  background-size: 100% 100%;
  .login-banner {
    width: 1289px;
    height: 661px;
    background: url('../assets/login_temp/login_puzzle.png') no-repeat center center;
    background-size: 100% 100%;
    //flex: 1;
    display:flex;
    justify-content:center;
    align-items: center;
    //position:relative;
    .login-pic{
      width:732px;
      height:661px;
      display:flex;
      justify-content:center;
      align-items: center;
      .house-image{
        width:519px;
        height:472px;
        margin-left:115px;
      }
    }
    .login-info{
      width:557px;
      height:661px;
      position: relative;
      display:flex;
      justify-content:center;
      align-items:center;
      flex-direction: column;
      .login-details{
        display:flex;
        justify-content:center;
        align-items: center;
        flex-direction: column;
        margin-right:43px;
        margin-bottom:20px;
        .wx-login-box-out{
          //margin-top:10px;
          .wx-login-box{
            width: 252px;
            height: 252px;
            border:none;
          }
        }
        .login-scan-desc{
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 700;
          color: #333333;
          opacity: 1;
          margin-top:40px;
        }
        .login-divide{
          width: 24px;
          height: 3px;
          background: #5D48FF;
          opacity: 1;
          margin:10px 0;
        }
        .login-name{
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 700;
          color: #333333;
          opacity: 1;
        }
        .login-pass{
          //position: absolute;
          //top:30%;
          //left:62%;
          //width:300px;
          .login-enter{
            display: flex;
            flex-direction: column;
            justify-content:flex-start;
            align-items:flex-start;
            margin-top:20px;
            /deep/.el-input__inner{
              border:none;
              padding:0;
            }
            .login-input{
              margin-top:10px;
              border-bottom: 0.00625rem solid #A5A7BE;
            }
            .login-input2{
              width:190px;
              margin-top:10px;
              border-bottom: 0.00625rem solid #A5A7BE;
            }
            .login-desc{
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 700;
              color: #333333;
              opacity: 1;
            }
          }
        }

        .loginBtn{
          width: 262px;
          height: 46px;
          background: #1362FF;
          box-shadow: 0px 3px 5px rgba(19, 98, 255, 0.5);
          opacity: 1;
          border-radius: 4px;
          line-height: 46px;
          color: #FFFFFF;
          font-size: 16px;
          margin-top:50px;
          cursor: pointer;
        }

      }

      .scan-image{
        width: 133px;
        height: 133px;
        position: absolute;
        top:0%;
        right:46px;
        cursor:pointer;
      }
      .tip-image{
        position: absolute;
        top:5%;
        right: 130px;
        cursor:pointer;
      }
    }

    //.login-message{
    //  position: absolute;
    //  width:300px;
    //  height:500px;
    //  top:18%;
    //  left:62%;
    //  display: flex;
    //  flex-direction: column;
    //  //justify-content:center;
    //  align-items: center;
    //  .login-wel{
    //    font-size: 36px;
    //    font-family: PingFang SC;
    //    font-weight: 700;
    //    color: #333333;
    //    opacity: 1;
    //  }
    //  .login-divide{
    //    width: 24px;
    //    height: 3px;
    //    background: #5D48FF;
    //    opacity: 1;
    //    margin:10px 0;
    //  }
    //  .login-name{
    //    font-size: 20px;
    //    font-family: PingFang SC;
    //    font-weight: 700;
    //    color: #333333;
    //    opacity: 1;
    //  }
    //}

    //.login-pass{
    //  position: absolute;
    //  top:30%;
    //  left:62%;
    //  width:300px;
    //  .login-enter{
    //    display: flex;
    //    flex-direction: column;
    //    justify-content:flex-start;
    //    align-items:flex-start;
    //    margin-top:20px;
    //    /deep/.el-input__inner{
    //      border:none;
    //      padding:0;
    //    }
    //    .login-input{
    //      margin-top:10px;
    //      border-bottom: 0.00625rem solid #A5A7BE;
    //    }
    //    .login-input2{
    //      width:190px;
    //      margin-top:10px;
    //      border-bottom: 0.00625rem solid #A5A7BE;
    //    }
    //    .login-desc{
    //      font-size: 16px;
    //      font-family: PingFang SC;
    //      font-weight: 700;
    //      color: #333333;
    //      opacity: 1;
    //    }
    //  }
    //}



    //.wx-login-box-out{
    //  position:absolute;
    //  top:38%;
    //  left:63.5%;
    //  .wx-login-box{
    //    width: 252px;
    //    height: 252px;
    //    border:none;
    //  }
    //}
    //.login-scan-desc{
    //  position:absolute;
    //  top:68%;
    //  left:64.5%;
    //  font-size: 20px;
    //  font-family: PingFang SC;
    //  font-weight: 700;
    //  color: #333333;
    //  opacity: 1;
    //}
  }
  //.qrcode .lightBorder{
  //  border:none;
  //}
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue